






















import Vue from "vue";

import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import LineChart from "@/components/Chart/LineChart.vue";
import { CameraImage } from "@/store/modules/CameraImage/interface";

export default Vue.extend({
  name: "DeviceMemCard",
  components: {
    StandartCard,
    LineChart
  },
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    datas: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      datacollection: {},
      colors: ["#b14dff", "#bc5265"]
    };
  },
  mounted(): void {
    this.fillData();
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: this.labels,
        datasets: this.format_data_dataset
      };
    },
    datas_per_hours(attr: string): Array<number> {
      return (this.datas as Array<CameraImage>).map((data) =>
        Math.round((data[attr as keyof CameraImage] as number) / 1024)
      );
    }
  },
  computed: {
    format_data_dataset(): Array<any> {
      const dataset: Array<any> = [];
      dataset.push({
        label: "Mémoire utilisée (kilos  octets)",
        data: this.datas_per_hours("lapi_mem"),
        borderColor: this.colors[0],
        borderWidth: 1,
        fill: false
      });
      return dataset;
    }
  },
  watch: {
    labels: {
      handler(): void {
        this.fillData();
      }
    }
  }
});
